module.exports = __webpack_public_path__ + "static/media/france.3b8a5407.svg";